import {
    apiRequest,
    recapDetailComponent
} from "../../../../../services/adapters/kepegawaian/penilaian360Service"

class PenilaianRepository 
{
    fetchRecapComponent = async (query) => {
        return await apiRequest("get", recapDetailComponent, {
            params: query
        }, true)
    }

}

export default PenilaianRepository